<template>
  <div class="page-class page-center"><div class="page-staff-form">
    <h1 class="page-title text-center">{{ isEdit ? 'Edit Closure Remark' : 'New Closure Remarks' }}</h1>
    <closure-remarks-form-box v-if="!isEdit || current" :initial="current" :is-edit="isEdit" :loading="loading" @submit="save" />
  </div></div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import ClosureRemarksFormBox from '../../../components/ClosureRemarksFormBox.vue';

function responseTemplateId(item) {
  // eslint-disable-next-line no-underscore-dangle
  return item.templateId || item.id || item._id;
}

export default {
  name: 'ClosureRemarksForm', components: { ClosureRemarksFormBox },
  computed: {
    ...mapState('qms', ['loading', 'responseTemplates']),
    isEdit() { return this.$route.name === 'qms-closure-remarks-edit'; },
    templateId() { return decodeURIComponent(this.$route.params.templateId || ''); },
    current() { return this.responseTemplates.find(item => String(responseTemplateId(item)) === this.templateId) || null; }
  },
  async mounted() { if (this.isEdit && !this.current) await this.listResponseTemplates({ router: this.$router }); },
  methods: {
    ...mapActions('qms', ['listResponseTemplates', 'saveResponseTemplates']),
    save(items) { const payload = this.isEdit ? { templateId: this.templateId, ...items[0] } : { responses: items }; this.saveResponseTemplates({ payload, edit: this.isEdit, router: this.$router }); }
  }
};
</script>
